import { render, staticRenderFns } from "./UnitRepresentativePage.vue?vue&type=template&id=5ed3632a&"
import script from "./UnitRepresentativePage.vue?vue&type=script&lang=ts&"
export * from "./UnitRepresentativePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed3632a')) {
      api.createRecord('5ed3632a', component.options)
    } else {
      api.reload('5ed3632a', component.options)
    }
    module.hot.accept("./UnitRepresentativePage.vue?vue&type=template&id=5ed3632a&", function () {
      api.rerender('5ed3632a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/UnitRepresentative/UnitRepresentativePage.vue"
export default component.exports